// Controls
import { Dropdown } from "./Dropdown";
// Utilities
import React, { useState, useEffect, useMemo, useCallback } from "react";
import debounce from "lodash/debounce";
/**
 * Debounced version of the custom Dropdown control
 */ export function DebouncedDropdown(props) {
    const [currentSelectedKey, setCurrentSelectedKey] = useState(props.selectedKey);
    useEffect(()=>{
        if (currentSelectedKey !== props.selectedKey) {
            setCurrentSelectedKey(props.selectedKey);
        }
    }, [
        props.selectedKey,
        currentSelectedKey
    ]);
    /** Debounced version of onChange function prop */ const debouncedOnChange = useMemo(()=>{
        return props.onChange ? debounce(props.onChange, props.debounceInterval) : ()=>{};
    }, [
        props.onChange,
        props.debounceInterval
    ]);
    /**
     * Callback for changing the dropdown value. Reflects changes immediately in the state/render, debounces onChange callback.
     */ const onChange = useCallback((event, option, index)=>{
        setCurrentSelectedKey(option?.key);
        debouncedOnChange(event, option, index);
    }, [
        debouncedOnChange
    ]);
    const { debounceInterval, children, ...passThroughProps } = {
        ...props,
        selectedKey: currentSelectedKey,
        onChange
    };
    return /*#__PURE__*/ React.createElement(Dropdown, passThroughProps, children);
}
